


export const localStorage = {
   EMPLOYEE_SESSION:'employeeSession',
   NOVU_FCM_TOKEN:'novuFcmToken',
   NOVU_FCM_PLATFORM:'novuFcmPlatform'
}